module.exports = __webpack_public_path__ + "img/32-image-1-1@2x.ccfc84d3.png";